import { TApplicationState } from 'shared/types/redux';

export const selectModalVisible = (state: TApplicationState) => {
  return state.modal.visible;
};
